const QuoteRequests = () => import("Modules/sales/quote_requests/views/QuoteRequests");
const QuoteRequestsForm = () => import("Modules/sales/quote_requests/views/QuoteRequestsForm");

export default {
    children: [
        {
            path: "sales/quote_requests",
            name: "quote_requests",
            component: QuoteRequests,
            meta: {
                requiresAuth: true,
                title: "lang.quote_requests",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["quote_requests.read"],
            },
        },
        {
            path: "sales/quote_request/:id?",
            name: "quote_request",
            component: QuoteRequestsForm,
            meta: {
                requiresAuth: true,
                title: "lang.quote_requests",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["quote_requests.read"],
            },
        },
    ],
};
